import React, { useContext } from "react"
import * as styles from "./Disabled.module.scss"
import { PriceContext } from "../PriceContext"

const Disabled = () => {
  const { text } = useContext(PriceContext)
  return <div className={styles.disabled}>{text.addonText.disabled}</div>
}

export default Disabled
